"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9757],{

/***/ 87082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* reexport */ BreadCrumbs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./src/contexts/HighlightContext/Highlight.tsx
var Highlight = __webpack_require__(78958);
// EXTERNAL MODULE: ./src/components/Link/index.tsx
var Link = __webpack_require__(7500);
// EXTERNAL MODULE: ./node_modules/@mui/material/Breadcrumbs/Breadcrumbs.js + 3 modules
var Breadcrumbs = __webpack_require__(12963);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(29769);
;// CONCATENATED MODULE: ./src/components/BreadCrumbs/BreadCrumbs.tsx








var BreadCrumbs_Link = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Link/* Link */.r, (0,_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
function BreadCrumbs(props) {
    var breadcrumbs = props.breadcrumbs;
    var theme = (0,useTheme/* default */.Z)();
    var crumbRefs = react.useRef([]);
    var t = (0,esm/* useTranslation */.$G)([
        "common"
    ]).t;
    // Todo: Fix crumbRefs.current typescript problem.
    // @ts-ignore
    crumbRefs.current = breadcrumbs.map(function(crumb, index) {
        var _index;
        // @ts-ignore
        return (_index = crumbRefs.current[index]) !== null && _index !== void 0 ? _index : /*#__PURE__*/ react.createRef();
    });
    if (!(props === null || props === void 0 ? void 0 : props.hidden)) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Breadcrumbs/* default */.Z, {
        "aria-label": "breadcrumb",
        sx: {
            margin: theme.spacing(2, 0)
        },
        children: breadcrumbs.map(function(crumb, index) {
            return breadcrumbs[breadcrumbs.length - 1] ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BreadCrumbs_Link, {
                // @ts-ignore
                ref: crumbRefs.current[index],
                underline: "hover",
                color: "text.primary",
                href: crumb.path,
                "aria-current": "page",
                variant: "body2",
                children: crumb.name === "Home" ? t("home", "Home") : crumb.name
            }, index) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BreadCrumbs_Link, {
                // @ts-ignore
                ref: crumbRefs.current[index],
                underline: "hover",
                color: "inherit",
                href: crumb.path,
                variant: "body2",
                children: crumb.name
            }, index);
        })
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
}

;// CONCATENATED MODULE: ./src/components/BreadCrumbs/index.ts



/***/ }),

/***/ 29757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ DefaultView; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 2 modules
var Container = __webpack_require__(53156);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./src/components/BreadCrumbs/index.ts + 1 modules
var BreadCrumbs = __webpack_require__(87082);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(98396);
// EXTERNAL MODULE: ./src/contexts/HighlightContext/Highlight.tsx
var Highlight = __webpack_require__(78958);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(55113);
// EXTERNAL MODULE: ./node_modules/react-markdown/lib/index.js + 117 modules
var lib = __webpack_require__(296);
;// CONCATENATED MODULE: ./src/components/DefaultContent/index.tsx










var DefaultContent_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
// @ts-ignore Todo: Complete type definitions for DefaultContent.
function DefaultContent(param) {
    var children = param.children, body = param.body;
    var theme = (0,useTheme/* default */.Z)();
    var md = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("md"));
    var h1Ref = react.useRef(null);
    var h2Ref = react.useRef(null);
    var h3Ref = react.useRef(null);
    var h4Ref = react.useRef(null);
    var h5Ref = react.useRef(null);
    var h6Ref = react.useRef(null);
    var subtitle1Ref = react.useRef(null);
    var subtitle2Ref = react.useRef(null);
    var body1Ref = react.useRef(null);
    var body2Ref = react.useRef(null);
    var buttonRef = react.useRef(null);
    var captionRef = react.useRef(null);
    var overlineRef = react.useRef(null);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Paper/* default */.Z, {
        elevation: 1,
        sx: {
            padding: theme.spacing(md ? 4 : 2),
            marginBottom: theme.spacing(md ? 4 : 2)
        },
        children: [
            children,
            body ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(lib/* Markdown */.U, {
                children: body
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        style: {
                            margin: theme.spacing(0, 0, 4)
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                variant: "subtitle1",
                                children: "Primary"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Grid/* default */.ZP, {
                                container: true,
                                spacing: 0,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.primary.light,
                                            padding: theme.spacing(2)
                                        },
                                        children: "light"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.primary.main,
                                            padding: theme.spacing(2)
                                        },
                                        children: "main"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.primary.dark,
                                            padding: theme.spacing(2)
                                        },
                                        children: "dark"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.primary.main,
                                            color: theme.palette.primary.contrastText,
                                            padding: theme.spacing(2)
                                        },
                                        children: "contrastText"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        style: {
                            margin: theme.spacing(0, 0, 4)
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                variant: "subtitle1",
                                children: "Secondary"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Grid/* default */.ZP, {
                                container: true,
                                spacing: 0,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.secondary.light,
                                            padding: theme.spacing(2)
                                        },
                                        children: "light"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.secondary.main,
                                            padding: theme.spacing(2)
                                        },
                                        children: "main"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.secondary.dark,
                                            padding: theme.spacing(2)
                                        },
                                        children: "dark"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.secondary.main,
                                            color: theme.palette.secondary.contrastText,
                                            padding: theme.spacing(2)
                                        },
                                        children: "contrastText"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        style: {
                            margin: theme.spacing(0, 0, 4)
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                variant: "subtitle1",
                                children: "Grey"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Grid/* default */.ZP, {
                                container: true,
                                spacing: 0,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.grey["50"],
                                            padding: theme.spacing(2)
                                        },
                                        children: "50"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.grey["100"],
                                            padding: theme.spacing(2)
                                        },
                                        children: "100"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.grey["200"],
                                            padding: theme.spacing(2)
                                        },
                                        children: "200"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.grey["300"],
                                            padding: theme.spacing(2)
                                        },
                                        children: "300"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.grey["400"],
                                            padding: theme.spacing(2)
                                        },
                                        children: "400"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.grey["500"],
                                            padding: theme.spacing(2)
                                        },
                                        children: "500"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.grey["600"],
                                            padding: theme.spacing(2)
                                        },
                                        children: "600"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.grey["700"],
                                            padding: theme.spacing(2)
                                        },
                                        children: "700"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.grey["800"],
                                            padding: theme.spacing(2)
                                        },
                                        children: "800"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.grey["900"],
                                            padding: theme.spacing(2)
                                        },
                                        children: "900"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.grey["A100"],
                                            padding: theme.spacing(2)
                                        },
                                        children: "A100"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.grey["A200"],
                                            padding: theme.spacing(2)
                                        },
                                        children: "A200"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.grey["A400"],
                                            padding: theme.spacing(2)
                                        },
                                        children: "A400"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            backgroundColor: theme.palette.grey["A700"],
                                            padding: theme.spacing(2)
                                        },
                                        children: "A700"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        style: {
                            margin: theme.spacing(0, 0, 4)
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                variant: "subtitle1",
                                children: "Text"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Grid/* default */.ZP, {
                                container: true,
                                spacing: 0,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            color: theme.palette.text["primary"],
                                            padding: theme.spacing(2)
                                        },
                                        children: "primary"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            color: theme.palette.text["secondary"],
                                            padding: theme.spacing(2)
                                        },
                                        children: "secondary"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        sx: {
                                            color: theme.palette.text["disabled"],
                                            padding: theme.spacing(2)
                                        },
                                        children: "disabled"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        style: {
                            margin: theme.spacing(0, 0, 4)
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                variant: "subtitle1",
                                children: "H1"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                ref: h1Ref,
                                variant: "h1",
                                children: "Almost before we knew it, we had left the ground."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        style: {
                            margin: theme.spacing(0, 0, 4)
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                variant: "subtitle1",
                                children: "H2"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                ref: h2Ref,
                                variant: "h2",
                                children: "Almost before we knew it, we had left the ground."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        style: {
                            margin: theme.spacing(0, 0, 4)
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                variant: "subtitle1",
                                children: "H3"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                ref: h3Ref,
                                variant: "h3",
                                children: "Almost before we knew it, we had left the ground."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        style: {
                            margin: theme.spacing(0, 0, 4)
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                variant: "subtitle1",
                                children: "H4"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                ref: h4Ref,
                                variant: "h4",
                                children: "Almost before we knew it, we had left the ground."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        style: {
                            margin: theme.spacing(0, 0, 4)
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                variant: "subtitle1",
                                children: "H5"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                ref: h5Ref,
                                variant: "h5",
                                children: "Almost before we knew it, we had left the ground."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        style: {
                            margin: theme.spacing(0, 0, 4)
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                variant: "subtitle1",
                                children: "H6"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                ref: h6Ref,
                                variant: "h6",
                                children: "Almost before we knew it, we had left the ground."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        style: {
                            margin: theme.spacing(0, 0, 4)
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                variant: "subtitle1",
                                children: "subtitle1"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                ref: subtitle1Ref,
                                variant: "subtitle1",
                                children: "Almost before we knew it, we had left the ground."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        style: {
                            margin: theme.spacing(0, 0, 4)
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                variant: "subtitle1",
                                children: "subtitle2"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                ref: subtitle2Ref,
                                variant: "subtitle2",
                                children: "Almost before we knew it, we had left the ground."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        style: {
                            margin: theme.spacing(0, 0, 4)
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                variant: "subtitle1",
                                children: "body1"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                ref: body1Ref,
                                variant: "body1",
                                children: "Almost before we knew it, we had left the ground."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        style: {
                            margin: theme.spacing(0, 0, 4)
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                variant: "subtitle1",
                                children: "body2"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                ref: body2Ref,
                                variant: "body2",
                                children: "Almost before we knew it, we had left the ground."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        style: {
                            margin: theme.spacing(0, 0, 4)
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                variant: "subtitle1",
                                children: "button"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                ref: buttonRef,
                                variant: "button",
                                children: "Almost before we knew it, we had left the ground."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        style: {
                            margin: theme.spacing(0, 0, 4)
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                variant: "subtitle1",
                                children: "caption"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                ref: captionRef,
                                variant: "caption",
                                children: "Almost before we knew it, we had left the ground."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        style: {
                            margin: theme.spacing(0, 0, 4)
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                variant: "subtitle1",
                                children: "overline"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent_Typography, {
                                ref: overlineRef,
                                variant: "overline",
                                children: "Almost before we knew it, we had left the ground."
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/DefaultView/index.tsx






// import { useTranslation } from 'next-i18next';
// import { useTheme } from '@mui/material/styles';

// import { useAppContext } from '../../contexts/AppContext';

var DefaultView_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
/**
 * This component is used as fallback view in case no component for a page
 * is set during a BigBang site build.
 *
 * This component can be used as example "view" component within our NPM framework.
 *
 * @param props AllViewProps (don't use the AllViewProps type, use a specific one instead.)
 * @constructor
 */ function DefaultView(props) {
    var // global,
    pageContext = props.pageContext, title = props.title, body = props.body;
    var h1Ref = react.useRef(null);
    // const theme = useTheme();
    // const appContext = useAppContext();
    // const {
    //   componentOptions,
    // } = appContext.useConfig();
    // const {
    //   user,
    //   isLoading,
    //   isError
    // } = appContext.useUser();
    // The 'common' translations namespace is passed on server side (getStaticProps) already.
    // const { t } = useTranslation();
    // React.useEffect(() => {
    //   console.info({
    //     global,
    //     pageContext,
    //     title,
    //     body,
    //     appContext,
    //     componentOptions,
    //     collections,
    //     collection,
    //     game,
    //   });
    // }, []); // eslint-disable-line react-hooks/exhaustive-deps
    // React.useEffect(() => {
    //   if (!user) return;
    //   console.info({ user });
    // }, [user]);
    // if (isLoading) return <div>loading...</div>
    // if (isError) return <div>failed to load</div>
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container/* default */.Z, {
        maxWidth: "md",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BreadCrumbs/* BreadCrumbs */.b, {
                breadcrumbs: pageContext.breadcrumbs
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultContent, {
                body: body,
                children: title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultView_Typography, {
                    ref: h1Ref,
                    component: "h1",
                    variant: "h1",
                    children: title
                })
            })
        ]
    });
}


/***/ }),

/***/ 78958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useHighlightHandlers; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2734);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54794);







// Todo: Have a hard time setting the type for Component, as it can be Mui Typography or our own Link component.
var useHighlightHandlers = function(Component, props) {
    var enabledVariants = (0,_index__WEBPACK_IMPORTED_MODULE_1__/* .useHighlightContext */ .A)().enabledVariants;
    var forwardedRef = props.forwardedRef, variant = props.variant, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, [
        "forwardedRef",
        "variant"
    ]);
    var theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var element = null;
    // Todo: Not sure how to resolve this missing current ts warning.
    // @ts-ignore
    if (forwardedRef && (forwardedRef === null || forwardedRef === void 0 ? void 0 : forwardedRef.current)) {
        // Todo: Not sure how to resolve this missing current ts warning.
        // @ts-ignore
        element = forwardedRef.current;
    }
    if (element && variant && Array.isArray(enabledVariants)) {
        if (enabledVariants.includes(variant)) {
            element.style.outline = "2px dotted ".concat(theme.palette.info.main);
            element.style.outlineOffset = "-2px";
            element.style.position = "relative";
            if (!element.querySelector(".typographyBadge")) {
                var badge = document.createElement("div");
                badge.classList.add("typographyBadge");
                badge.style.position = "absolute";
                badge.style.top = theme.spacing(-0.5);
                badge.style.right = theme.spacing(-0.5);
                badge.style.backgroundColor = theme.palette.info.main;
                badge.style.borderRadius = "".concat(theme.shape.borderRadius, "px");
                badge.style.color = theme.palette.info.contrastText;
                badge.style.fontSize = "10px";
                badge.style.lineHeight = "10px";
                badge.style.padding = theme.spacing(0.5, 1);
                badge.style.boxShadow = theme.shadows[1];
                badge.style.textTransform = "capitalize";
                badge.innerText = [
                    "contained",
                    "text",
                    "outlined"
                ].includes(variant) ? "button" : variant;
                element.appendChild(badge);
            }
        } else {
            var ref;
            element.style.outline = "unset";
            (ref = element.querySelector(".typographyBadge")) === null || ref === void 0 ? void 0 : ref.remove();
        }
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Component, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, rest), {
        variant: variant,
        ref: forwardedRef
    }));
};


/***/ })

}]);